var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n    font-family: 'georgiai';\r\n    src: url(" + escape(require("./georgiai.ttf")) + ");\r\n}\r\n\r\n@font-face {\r\n    font-family: 'calibril';\r\n    src: url(" + escape(require("./calibril.ttf")) + ");\r\n}\r\n\r\n@font-face {\r\n    font-family: 'bahnschrift';\r\n    src: url(" + escape(require("./bahnschrift.ttf")) + ");\r\n}\r\n\r\n", ""]);

// exports
